import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { useSelector } from 'react-redux';
import { VerificationSelector } from '../../store/Verification';


export const useVerificationGuard = () => {
  const navigate = useNavigate();
  const { isVerified } = useSelector(VerificationSelector.getVerificationState);
  
  useEffect(() => {
    if (!isVerified) {
      navigate('/test-strip/verify-email');
    }
  }, [isVerified, navigate]);

  return isVerified;
};